import React from 'react';

// components
import KategoriaTowaryGrid from './KategoriaTowaryGrid/KategoriaTowaryGrid';

// types
import { KategoriaTowaryProps } from './types';

interface WithKategoriaTowaryEnhanced {
  renderKategoriaTowaryGrid(
    gridCompProps: KategoriaTowaryProps,
    dxDataGridCustomOpts: unknown
  ): JSX.Element;
}

const withKategoriaTowaryGrid = <TWrappedProps,>(
  WrappedComponent: React.FC<TWrappedProps & WithKategoriaTowaryEnhanced>
) => (props: TWrappedProps) => (
  <WrappedComponent
    {...props}
    renderKategoriaTowaryGrid={(gridCompProps, dxDataGridCustomOpts = {}) => (
      <KategoriaTowaryGrid
        {...gridCompProps}
        dxDataGridCustomOpts={dxDataGridCustomOpts}
      />
    )}
  />
);

export default withKategoriaTowaryGrid;
